<template>
  <aside class="sidebar-container unselectable-text">
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      mode="vertical"
      background-color="#fafafa"
      text-color="#707070"
      active-text-color="#4BA7A2">
      <sidebar-item
        v-for="route in filteredRoutes"
        :key="route.name"
        :level="0"
        :route-object="route"
        :base-path="route.path"/>
    </el-menu>
    <a
      class="toggle-sidebar-button"
      role="button"
      type="button"
      @click="toggleSideBar">
      <font-awesome-icon
        v-if="!isSideBarOpen"
        icon="angle-double-right"
        class="font-awesome-icon"/>
      <template v-else>
        <font-awesome-icon
          icon="angle-double-left"
          class="font-awesome-icon"/>
        <span class="collapse-text">Collapse Sidebar</span>
      </template>
    </a>
  </aside>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { routes } from '../../../../router'
import { getFilteredRoutesByAccessibleRouteNames } from '../../../../utils/routeBasePermissionCheck'
import SidebarItem from './SidebarItem.vue'

export default {
  components: {
    SidebarItem,
  },
  data() {
    return {
      filteredRoutes: [],
    }
  },
  computed: {
    ...mapGetters({
      isSideBarOpen: 'app/isSideBarOpen',
      accessibleRoutes: 'user/accessibleRoutes',
    }),
    isCollapse() {
      return !this.isSideBarOpen
    },
  },
  mounted() {
    this.getRoutes()
  },
  methods: {
    ...mapActions({
      toggleSideBar: 'app/toggleSideBar',
    }),
    getRoutes() {
      this.filteredRoutes = getFilteredRoutesByAccessibleRouteNames(routes, this.accessibleRoutes)
    },
  },
}
</script>
